import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import '../../styles/main.scss';

const RAGSystem = () => {
  const navigate = useNavigate();
  const streamlitUrl =
    process.env.REACT_APP_STREAMLIT_URL || 'http://localhost:8501';

  return (
    <div
      className="ibeam-container rag-system-container"
      style={{
        padding: '16px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 120px)',
      }}
    >
      <div
        className="flex items-center justify-between w-full mb-4 pb-3 border-b chat-header"
        style={{ borderBottomColor: 'var(--border-color)', flexShrink: 0 }}
      >
        <h2
          className="page-title"
          style={{ color: 'var(--text-primary)', marginBottom: 0 }}
        >
          RAG System
        </h2>
        <button
          type="button"
          className="btn-validate"
          onClick={() => navigate(ROUTES.DASHBOARD)}
        >
          <span className="btn-label">Back</span>
        </button>
      </div>

      <iframe
        title="RAG System"
        src={streamlitUrl}
        className="rag-system-iframe"
        style={{
          flex: 1,
          width: '100%',
          border: '1px solid var(--border-color)',
          borderRadius: '8px',
          backgroundColor: 'var(--bg-primary)',
        }}
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
};

export default RAGSystem;
